export default __webpack_public_path__ + "assets/fe604a767ee3b9a901ab5f2c15131156.png";